import React, { useEffect } from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Box, Grid, Paper } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxLine: {
        border: '1px solid #ebdcc6',
        borderRadius: '4px',
        boxShadow: 'none',
        padding: 10,
        backgroundColor: '#ffffff'
    },
    boxTitle: {
        paddingBottom: 10,
        paddingTop: 10,
        fontWeight: 'bold',
        fontSize: '18px'
    },
  }),
);

interface IProps {
  title: string,
  data: any,
  show: string
}

const PartnerList: React.FC<IProps> = ({
  title,
  data,
  show
}) => {
  useEffect(() => { }, []);

  const classes = useStyles();

  return (
    <Box className={classes.boxTitle} pl={3} pr={3} display={show}>
        <FormattedMessage id={title} />
    <Box pt={2} />
        <Grid container spacing={3}>
            {data.map((item: { image: string; name: string | undefined; }) => {
                return (
                    <Grid item xs={6} sm={2}>
                        <Paper className={classes.boxLine}>
                            <img src={"/images/partners/" + item.image} alt={item.name} width="100%" />
                        </Paper>
                    </Grid>
                )
            }
            )}
        </Grid>
    </Box>
  );
};

export default (PartnerList);
